import { shownConfs } from '@fcom/core/reducers/langs';
import { CountryLanguage, CountryState } from '@fcom/core/interfaces';

import { Links } from '../services';

export interface DetectedSelection {
  country: string;
  languageCode: string;
}

const INTERNATIONAL: DetectedSelection = { country: 'INT', languageCode: 'en' };

const parseLocalizedPathFromUrl = (langCode: string, url: string): string => {
  const everythingBeforeLangCode = new RegExp(`.+?(?=/${langCode})`);
  return url ? url.replace(everythingBeforeLangCode, '') : `/${langCode}`;
};

export const getLocalizedLinkForLangCode = (langCode: string, links: Links = {}, prevPageUrl: string): string => {
  const localizedCmsPageUrl = parseLocalizedPathFromUrl(langCode, links[langCode]);
  const localizedPrevPageUrl = prevPageUrl ? `/${langCode}${prevPageUrl}` : undefined;
  return localizedPrevPageUrl ?? localizedCmsPageUrl;
};

export const resolveDetectedSelection = (
  geoipCountryCode: string | undefined,
  browserLanguage: string | undefined,
  countries: CountryState[]
): DetectedSelection => {
  const matchedCountry = countries.find((country) => country.code === geoipCountryCode?.toUpperCase());
  if (!matchedCountry) {
    return INTERNATIONAL;
  }

  const browserSubtag = browserLanguage?.split('-')?.[0]?.toLowerCase();
  const matchedLanguage = matchedCountry.languages.find((language) => language.ISOCode === browserSubtag);

  return {
    country: matchedCountry.code,
    languageCode: matchedLanguage?.code ?? matchedCountry.languages[0].code,
  };
};

export const getCountryStates = (): CountryState[] =>
  shownConfs
    .map((country) => ({
      ...country,
      languages: country.languages.map((language): CountryLanguage => {
        const translation = language.translation ? ` (${language.translation})` : '';
        return {
          ...language,
          label: `${country.name}, ${language.name}${translation}`,
          ISOCode: language.code.split('-').pop(),
        };
      }),
    }))
    .reduce((countryList, country) => {
      // Set Finland as first country in the list
      if (country.code === 'FI') {
        countryList.unshift(country);
      } else {
        countryList.push(country);
      }
      return countryList;
    }, []);
